// Lightweight per-visitor progress store. Everything lives in localStorage —
// no account, no server, no PII.

const KEY = "pa_playbook_progress_v1";

const safeRead = () => {
  try {
    if (typeof window === "undefined") return {};
    const raw = window.localStorage.getItem(KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === "object" ? parsed : {};
  } catch {
    return {};
  }
};

const safeWrite = (obj) => {
  try {
    if (typeof window === "undefined") return;
    window.localStorage.setItem(KEY, JSON.stringify(obj));
  } catch {
    /* ignore quota / private mode failures */
  }
};

export const getCompletedSlugs = () => {
  const obj = safeRead();
  return Object.keys(obj).filter((k) => obj[k] === true);
};

export const isCompleted = (slug) => safeRead()[slug] === true;

export const markCompleted = (slug) => {
  const obj = safeRead();
  obj[slug] = true;
  safeWrite(obj);
};

export const markIncomplete = (slug) => {
  const obj = safeRead();
  delete obj[slug];
  safeWrite(obj);
};

export const resetProgress = () => safeWrite({});
